<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.printer">
    <div *ngIf="!isOtpVerified">
        <app-templates [ctryCode]="ctryCode" [businessId]="businessId" [isOfflineServiceAvailable]="false"
            (onSaved)="onIsPrinterTabAvailable(true)" [interactionType]="interactionType" />
    </div>
    <div *ngIf="!isOtpVerified && businessId && businessId.length > 5" class="local_printer_footer">
        <app-otp-container (onVerified)="onVerifiedOtp($event)" [isShowRequestOtp]="true" [businessId]="businessId"
            [otpType]="11" [interactionType]="interactionType" [additionalData]="additionalData"
            [isOtpVerified]="isOtpVerified" />
    </div>
    <div class="banner" *ngIf="isOtpVerified">
        <div *ngIf="isOfflineServiceAvailable == null" style="margin: 20px;">
            <label>{{localService.languageContent.printer.checking}}</label>
        </div>
        <div *ngIf="isOfflineServiceAvailable != null && printerSetup">
            <div style="margin: 5px;">
                <div class="row">
                    <div class="col-md-4">
                        <div>
                            <button class="button_icon icon_adjust"
                                [ngStyle]="{'color' : isOfflineServiceAvailable ? 'green' : 'red'}"
                                (click)="onAction(1)">refresh</button>
                            <span>{{isOfflineServiceAvailable ?
                                localService.languageContent.printer.localPrinterAvailable :
                                localService.languageContent.printer.localPrinterUnAvailable}}</span>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div>
                            <app-label [Text]="localService.languageContent.printer.yourDeviceId" />
                            <span class="en">{{deviceId}}</span>
                            <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;"
                                (click)="onAction(5)">content_copy</button>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <button class="button_icon icon_adjust"
                            title="{{printerSetup.Key && printerSetup.IsOn ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                            (click)="onActiveInactiveStatus(printerSetup.Key)" [disabled]="!printerSetup.Key"
                            [ngStyle]="{'color': printerSetup.Key && printerSetup.IsOn  ? 'yellowgreen' : 'orangered' }">{{printerSetup.Key
                            && printerSetup.IsOn
                            ?
                            "toggle_on" : "toggle_off"}}</button>
                        <span>{{localService.languageContent.printer.on_off}}</span>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-5" style="text-align: right;">
                                <app-label [Text]="localService.languageContent.printer.tempFolder" />
                            </div>
                            <div class="col-7">
                                <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                    [(ngModel)]="printerSetup.TemporaryFolder"
                                    title="{{localService.languageContent.printer.tempFolder}}"
                                    placeholder="{{localService.languageContent.printer.tempFolder}}" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-5" style="text-align: right;">
                                <app-label [Text]="localService.languageContent.printer.service_url" />
                            </div>
                            <div class="col-7">
                                <input autocomplete="off" type="text" style="margin-bottom: 10px;"
                                    [(ngModel)]="printerSetup.ServiceUrl"
                                    title="{{localService.languageContent.printer.service_url}}"
                                    placeholder="{{localService.languageContent.printer.service_url}}" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label style="margin-left: 10px;">
                            <input type="checkbox" [(ngModel)]="printerSetup.IsOfflineApplication">
                            <span
                                style="font-weight: normal;">{{localService.languageContent.printer.is_offline}}&nbsp;</span>
                        </label>
                        <button class="btn btn-primary" (click)="onSave()" style="float: right;">
                            <i class="material-icons"
                                style="color: white;top: 5px;position: relative;">{{!printerSetup.Key ? 'add' :
                                'save'}}</i>
                            <span>{{!printerSetup.Key ? localService.languageContent.common.create :
                                localService.languageContent.common.save}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isOtpVerified">
        <app-tab *ngIf="tabs" [tabs]="tabs" [(selectedKey)]="selectedTab" [isShowRefresh]="true"
            (onRefresh)="onAction(7)" />
        <div style="margin: 20px;">
            <app-printer-device-map *ngIf="selectedTab == PrinterTab.DeviceMapping.toString()"
                (onPreDataRequired)="onAction(2)" [ctryCode]="ctryCode" [businessId]="businessId"
                [isOfflineServiceAvailable]="isOfflineServiceAvailable" (onSaved)="onIsPrinterTabAvailable(false)" />
            <app-devices *ngIf="selectedTab == PrinterTab.Devices.toString()" (onPreDataRequired)="onAction(6)"
                [businessId]="businessId" [ctryCode]="ctryCode" [isOfflineServiceAvailable]="isOfflineServiceAvailable"
                (onSaved)="onIsPrinterTabAvailable(false)" />
            <app-printer-template-map *ngIf="selectedTab == PrinterTab.TemplateMapping.toString()"
                (onPreDataRequired)="onAction(3)" [ctryCode]="ctryCode" [businessId]="businessId"
                [isOfflineServiceAvailable]="isOfflineServiceAvailable" (onSaved)="onIsPrinterTabAvailable(false)" />
            <app-templates *ngIf="selectedTab == PrinterTab.Templates.toString()" [ctryCode]="ctryCode"
                [businessId]="businessId" [isOfflineServiceAvailable]="isOfflineServiceAvailable"
                (onSaved)="onIsPrinterTabAvailable(false)" [isOtpVerified]="isOtpVerified"
                [interactionType]="interactionType" />
            <app-available-printers
                *ngIf="isOfflineServiceAvailable == true && selectedTab == PrinterTab.AvailablePrinters.toString()"
                (onPreDataRequired)="onAction(4)" [ctryCode]="ctryCode" [businessId]="businessId"
                [isOfflineServiceAvailable]="isOfflineServiceAvailable" (onSaved)="onIsPrinterTabAvailable(false)" />
            <div *ngIf="selectedTab == PrinterTab.AvailablePrinters.toString() && isOfflineServiceAvailable == false"
                style="text-align: center;font-size: 25px;margin-top: 10%;">
                <span>{{localService.languageContent.printer.unavailable_message}}</span>
                <a class="button" [routerLink]="['/guide/1/99']" style="margin-left: 10px;">
                    <span>{{localService.languageContent.printer.read_more}}</span>
                </a>
            </div>
        </div>
    </div>
</div>
<span style="display:none;">
    <input type="button" class="on_language_changed" (click)="onLanguageChanged()" />
</span>